import React, {useEffect} from "react";
import PropTypes from "prop-types";

import userPic from "../assets/images/default-picture.png";

const Practitioner = props => {  

  return(
  <div className="practitioner-container d-flex flex-row justify-content-between">
    <div className="d-flex flex-row align-items-center" onClick={(event) => props.handleClick(event, props.userData)}>
      <div className="pic-status-container position-relative">
        <img
          className="rounded-circle pract-pic"
          src={props.userData && props.userData.doctorId && props.userData.doctorId.profilePic ? props.userData.doctorId.profilePic.original : props.userPic}
          alt="pract-pic"
        />
        {
          props.status !== undefined && (
            <div className={props.status ? "pract-status online-status" : "pract-status busy-status"}>

            </div>
          )
        }

      </div>
      <p className="prac-name d-flex flex-row flex-wrap position-relative">
        <span>{props.pracName}</span>&nbsp;<span>({props.pracType})</span>
        {props.showCrossIcon === true && (
          <i className="fa fa-times fa-2x error exit-queue-icon pract-cross-icon" onClick={(event) => props.removeCompleteDocChat(event, props.userData)}></i>
        )}
      </p>
    </div>

    {props.messageCount !== 0 && (
      <p className="prac-message-count" onClick={(event) => props.readChatList(event, props.userData)}>{props.messageCount}</p>
    )}
  </div>
);
};

export default Practitioner;

Practitioner.defaultProps = {
  userPic: userPic,
  messageCount: 0,
  showCrossIcon: false
};

Practitioner.prototype = {
  userPic: PropTypes.string,
  status: PropTypes.bool,
  pracName: PropTypes.string,
  pracType: PropTypes.string,
  messageCount: PropTypes.number,
  showCrossIcon: PropTypes.bool,
  handleClick: PropTypes.handleClick,
  readChatList: PropTypes.readChatList
};


// import React from "react";
// import PropTypes from "prop-types";

// import userPic from "../assets/images/default-picture.png";

// const Practitioner = props => (
//   <div className="practitioner-container d-flex flex-row justify-content-between">
//     <div className="d-flex flex-row align-items-center">
//       <div className="pic-status-container position-relative">
//         <img
//           className="rounded-circle pract-pic"
//           src={props.userPic}
//           alt="pract-pic"
//         />
//         <div
//           className={
//             props.status
//               ? "pract-status online-status"
//               : "pract-status busy-status"
//           }
//         ></div>
//       </div>
//       <p className="prac-name d-flex flex-row flex-wrap position-relative">
//         <span>{props.pracName}</span>&nbsp;<span>({props.pracType})</span>
//         {props.showCrossIcon === true && (
//           <i className="fa fa-times fa-2x error exit-queue-icon pract-cross-icon"></i>
//         )}
//       </p>
//     </div>
//     {props.messageCount !== 0 && (
//       <p className="prac-message-count">{props.messageCount}</p>
//     )}
//   </div>
// );

// export default Practitioner;

// Practitioner.defaultProps = {
//   userPic: userPic,
//   status: false,
//   messageCount: 0,
//   showCrossIcon: false
// };

// Practitioner.prototype = {
//   userPic: PropTypes.string,
//   status: PropTypes.bool,
//   pracName: PropTypes.string,
//   pracType: PropTypes.string,
//   messageCount: PropTypes.number,
//   showCrossIcon: PropTypes.bool
// };
